import { useTranslation } from "react-i18next";

const MainSlide = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col justify-center h-full lg:mr-[50px] max-w-[870px] align-start">
      <img
        src="/assets/img/logo/erllecta_logo_light.png"
        alt="erllecta logo"
        style={{ width: "300px", marginBottom: "50px" }}
      />
      <h2 className="font-serif font-light text-[52px] text-white leading-[52px] tracking-[0px] lg:text-[45px] lg:leading-[45px] md:text-[40px] md:leading-[40px] sm:text-[30px] sm:leading-[30px] sm:-tracking-[.5px] xs:text-[30px] xs:leading-[30px]">
        <span className="font-semibold block">
          {t("page.main.slider.0.firsttitle")}
        </span>
      </h2>
    </div>
  );
};

export default MainSlide;
